<template>
    <tr>
      <td class="ta_c fst"><a :href="`kwtp://uscode=${item.kwSymbol}`">{{item.symbol}}</a></td>
      <td>{{item.kwName}}</td>
      <td class="ta_c">
          <div v-if="item.fqDate">{{item.fqDate}}/{{item.fiscalFlag}}</div>
      </td>
      <td class="ta_c">{{item.earningsDate}} {{item.earningsTime}}</td>
      <td class="ta_r">
        <div v-if="item.eps">{{item.eps}}</div>
        <div v-else>-</div>
      </td>
      <td class="ta_r">{{item.epsQ}}</td>
      <td class="ta_r">{{item.surpValue}}</td>
      <td :class="`ta_r ${item.cssName}`">
        <div v-if="item.surpRatio">{{item.surpRatio}}</div>
        <div v-else>-</div>
      </td>
      <td class="ta_r lst">{{item.marketCap}}</td>
    </tr>
</template>

<script>
export default {
  props: {
    item: Object
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/pc/Erecord_sub.vue